import React from 'react';
import { withRouter } from 'react-router-dom';
import { ListItemSecondaryAction } from '@mui/material';
import { StyledRowItem, StyledDivider } from './styles';
import { get } from 'global/lib/lodash';
import { getReadIcon, getIconCourse } from '../definitions';
import clsx from 'clsx';
import { Column, Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { canContinue } from '../CourseDocument';

export default withRouter((props) => {
  const { match } = props;

  const item = get(props, 'item');
  const id = get(item, 'id');

  const locationProps = get(props, 'location.state', {});

  const RightIcons = (keyIndex) => {
    const icos = [{ search: 'checklist' }, { search: 'step_by_step' }, { search: 'sowId' }, { search: 'library_file' }, { search: 'library_video' }, { search: 'assessment' }].filter(
      (ico) => get(item, 'documentableType') === ico.search
    );

    return (
      <div>
        {icos.map((ico) => {
          return (
            <div key={`${ico.search}-${keyIndex}`}>
              {getIconCourse(ico.search)}
            </div>
          );
        })}
      </div>
    );
  };

  if (item.id === '_divider_') {
    return (
      <StyledDivider>
        <Text className="dividertext">{get(item, 'title', 'N/A')}</Text>
      </StyledDivider>
    );
  }

  const getDocPath = () => {
    const spl = window.location.pathname.split('/');
    const ind = spl.findIndex((d) => d === 'document');
    if (ind > -1) {
      return spl[ind + 1];
    } else {
      return null;
    }
  };

  const currentIndex = get(props, 'data', []).findIndex((d) => d.id == id);
  const prev = get(props, `data.${currentIndex - 1}.id`) == '_divider_' ? get(props, `data.${currentIndex - 2}`) : get(props, `data.${currentIndex - 1}`);
  const canClick = canContinue(item, locationProps) || !prev || canContinue(prev, locationProps);

  const disabled = !canClick;

  const onClick = () => {
    if (canClick) {
      props.history.push(`/courses/${match.params.id}/document/${id}`, get(props, 'location.state', {}));
    } else {
      alert('Please complete the previous course document before continuing.');
    }
  };

  const viewOfStudent = () => {
    return canContinue(item) || !prev || canContinue(prev) ? '' : 'disabled';
  };

  const isActive = getDocPath() === id;

  const reads = get(item, 'reads', []);

  return (
    <StyledRowItem
      onClick={onClick}
      key={item.id}
      selected={isActive}
      className={clsx(locationProps.isReview && viewOfStudent())}
      disabled={disabled}
    >
      <Row className="mainRow">
        {getReadIcon({ ...item, reads })}
        <Column className="textContainer">
          <Text type="title_medium" bold>
            {get(item, 'document.name', 'N/A')}
          </Text>
          <Text type="label_medium">{get(item, 'meta.duration', '0:00')}</Text>
        </Column>
        <ListItemSecondaryAction>
          <RightIcons keyIndex={item.id} />
        </ListItemSecondaryAction>
      </Row>
    </StyledRowItem>
  );
});
